export const formatFieldValue = (value: string | null | undefined): string => {
  return value?.trim() || '—';
};

export const formatAddress = (
  address1?: string | null,
  address2?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null
): string => {
  const parts: string[] = [];

  if (address1?.trim()) parts.push(address1.trim());
  if (address2?.trim()) parts.push(address2.trim());

  const cityStateZip: string[] = [];
  if (city?.trim()) cityStateZip.push(city.trim());
  if (state?.trim()) cityStateZip.push(state.trim());
  if (zip?.trim()) cityStateZip.push(zip.trim());

  if (cityStateZip.length > 0) {
    parts.push(cityStateZip.join(', '));
  }

  return parts.length > 0 ? parts.join(', ') : '—';
};

export const formatCompactDate = (
  dateStr: string | null | undefined
): string => {
  if (!dateStr) return '';

  try {
    // Fix the API's malformed timezone format: remove dot before timezone
    const fixedDate = dateStr.replace(/\.(-|\+)/, '$1');
    const date = new Date(fixedDate);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return '';
    }

    // Get UTC date components to avoid timezone shifts
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];
    const month = monthNames[date.getUTCMonth()];
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();

    return `${month} ${day}, ${year}`;
  } catch {
    return '';
  }
};
